module.exports = __webpack_public_path__ + "static/img/icon-add-posts.17737326.png";